var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("402")]),_c('span',[_vm._v("厨神菜单")])])]),_c('div',{staticClass:"art"},[_c('img',{attrs:{"src":require("../assets/banner.jpg"),"alt":""}})])])
}]

export { render, staticRenderFns }